import * as React from 'react';

import { Col, ConsoleDialog, Row } from '@rematter/ui-web';

import { useSettingsLocation } from '../../_state/settingsModule.state';
import { useTranslations } from '../../i18n/useTranslations';

import { SettingsMenu } from './SettingsMenu';

import { NavItem } from '~/shared/routing/createModuleNav';

type SettingsRootLayoutProps = {
  children: React.ReactNode;
  moduleNavigation?: NavItem;
};

export const SettingsRootLayout = ({ children }: SettingsRootLayoutProps) => {
  const t = useTranslations();
  const [, setLocation] = useSettingsLocation();

  return (
    <ConsoleDialog
      className="@SettingsRootLayout"
      contentClassName="p-0 flex-1"
      content={
        <Row className={'h-full'} yStretch>
          <Col
            className={'shrink-0 overflow-y-auto border-r border-neutral/10'}
          >
            <SettingsMenu />
          </Col>
          <Col className={'h-full w-full overflow-y-auto'}>{children}</Col>
        </Row>
      }
      title={t.settingsLayout.title}
      size="fill"
      isOpen
      onOpenChange={() => setLocation(undefined)}
      closeWithEscapeKey={false}
      closeOnClickOutside={false}
    />
  );
};
